export default __webpack_public_path__ + "static/media/power.9857f5ff.svg";